:host {
  --columns: 1;
  --columns-gap: #{$gridGutter};
  --list-display: grid;
  --list-margin-right: calc(var(--columns-gap) / -1);
  --list-grid-template-columns: repeat(var(--columns), auto minmax(auto, 1fr) auto var(--columns-gap));
  --full-grid-column: 1 / 5;
  --nested-margin-left: var(--stzh-datalist-nested-margin-left, 0px);
  --details-content-width: var(--stzh-datalist-details-content-width, 100%);

  --grid-template-areas: var(
      --stzh-datalist-grid-template-areas,
      "list list list list"
  );

  --grid-template-columns: var(
      --stzh-datalist-grid-template-columns,
      #{$gridColumns}
  );

  margin-left: var(--nested-margin-left);

  @include mq($from: small) {
    --columns-gap: #{$gridGutterSmall};

    --grid-template-areas: var(
        --stzh-datalist-grid-template-areas,
        "list list list list"
    );
  }

  @include mq($from: medium) {
    --columns-gap: #{$gridGutterMedium};

    --grid-template-areas: var(
        --stzh-datalist-grid-template-areas,
        "list list list list list list list list"
    );

    --grid-template-columns: var(
        --stzh-datalist-grid-template-columns,
        #{$gridColumnsMedium}
    );
  }

  @include mq($from: large) {
    --columns-gap: #{$gridGutterLarge};
  }

  @include mq($from: ultra) {
    --columns-gap: #{$gridGutterUltra};
  }
  // datalist-item or wrapper elements should be set to display: contents to make grid layout work.
  // in AEM edit mode: we prevent setting it, so the links can still be edited.

  ::slotted(.layout_column) > *:not([class*="cq-"]),
  ::slotted(*:not([class*="cq-"])) {
    display: contents;
  }

  &[is-direction="horizontal"] {
    --list-grid-template-columns: repeat(var(--columns), auto minmax(auto, 1fr) auto auto var(--columns-gap));
    --full-grid-column: 1 / 6;

    &:where(:has(stzh-datalist-item:not([meta=""]))),
    &:where(:has(stzh-datalist-item:not([status-label=""]))) {
      --list-grid-template-columns: repeat(var(--columns), auto minmax(auto, 1fr) minmax(auto, 1fr) auto var(--columns-gap));
    }
  }

  &[variant="table"] {
    --list-grid-template-columns: repeat(var(--columns), auto auto minmax(auto, 1fr) auto auto var(--columns-gap));
    --full-grid-column: 1 / 7;

    &:where(:has(stzh-datalist-item:not([meta=""]))),
    &:where(:has(stzh-datalist-item:not([status-label=""]))) {
      --list-grid-template-columns: repeat(var(--columns), auto auto minmax(auto, 1fr) minmax(auto, 1fr) auto var(--columns-gap));
    }
  }
}

/* AEM edit mode: we set list as block element (always as one column), to prevent layout breaks */

:host(:has([class*="cq-"])) {
  --stzh-datalist-item-wrapper-display: flex;

  --list-display: block;
  --list-margin-right: 0;
}

.stzh-datalist {
  // offset margin of nested datalist
  --stzh-datalist-nested-margin-left: #{space('large')};
  // details grid columns
  --stzh-details-content-grid-column: var(--full-grid-column);
  --stzh-details-content-padding-right: var(--columns-gap);
  --stzh-details-content-width: var(--details-content-width);

  @include gridGutter;
  display: grid;
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);

  &__wrapper {
    grid-area: list;
    overflow: visible;
  }

  &__list {
    display: var(--list-display);
    border-collapse: collapse;
    grid-template-columns: var(--list-grid-template-columns);
    align-items: stretch;
    margin-right: var(--list-margin-right);
  }

  /* Multiple Columns */

  &--has-multiple-columns {
    // display of nested datalist
    --stzh-datalist-item-nested-display: none;
  }

  /* Table variant with big label */

  &--table#{&}--big-label &__list {
    @include mq($to: small) {
      --list-display: flex;
      flex-direction: column;
      gap: space('xxxsmall');
    }
  }
}
